/** Display-only camera, in cells: the top-left cell of the view (fractional while scrolling). */
export class Camera {
  x = 0;
  y = 0;
  /** Screen pixels per cell (half the normal scale in wide view). */
  scale = 1;
  screenW = 1;
  screenH = 1;

  constructor(readonly mapW: number, readonly mapH: number) {}

  get spanW(): number { return this.screenW / this.scale; }
  get spanH(): number { return this.screenH / this.scale; }

  resize(screenW: number, screenH: number, scale: number): void {
    const cx = this.x + this.spanW / 2;
    const cy = this.y + this.spanH / 2;
    this.screenW = screenW;
    this.screenH = screenH;
    this.scale = scale;
    this.centerOn(cx, cy);
  }

  /** Changes the scale keeping the cell under screen point (sx, sy) in place. */
  zoomAt(scale: number, sx: number, sy: number): void {
    const cx = this.x + sx / this.scale;
    const cy = this.y + sy / this.scale;
    this.scale = scale;
    this.x = cx - sx / scale;
    this.y = cy - sy / scale;
    this.clamp();
  }

  centerOn(cx: number, cy: number): void {
    this.x = cx - this.spanW / 2;
    this.y = cy - this.spanH / 2;
    this.clamp();
  }

  panByScreen(dx: number, dy: number): void {
    this.x -= dx / this.scale;
    this.y -= dy / this.scale;
    this.clamp();
  }

  screenToCell(sx: number, sy: number): [number, number] {
    return [Math.floor(this.x + sx / this.scale), Math.floor(this.y + sy / this.scale)];
  }

  /** GDD: the camera never leaves the map; a map smaller than the view is centred. */
  private clamp(): void {
    this.x = this.spanW >= this.mapW ? (this.mapW - this.spanW) / 2 : Math.min(Math.max(this.x, 0), this.mapW - this.spanW);
    this.y = this.spanH >= this.mapH ? (this.mapH - this.spanH) / 2 : Math.min(Math.max(this.y, 0), this.mapH - this.spanH);
  }
}
